export default __webpack_public_path__ + "static/media/SingleColumnBinderRings.ca6eea08.png";